//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cardListPanel from '../collectCard/components/cardListPanel.vue';
import MaterialReceiveList from '../collectCard/components/materialReceiveList.vue';
import MaterialReturnList from '../collectCard/components/materialReturnList.vue';
export default {
  name: 'material-receive-list',
  components: {
    cardListPanel: cardListPanel,
    MaterialReceiveList: MaterialReceiveList,
    MaterialReturnList: MaterialReturnList
  },
  data: function data() {
    return {
      subActiveName: '1',
      type: '0',
      materialReceiveCode: '',
      // 跳转其他物料领用时回填的申请单号
      subTabs: [{
        label: '领卡列表',
        name: '1',
        component: 'cardListPanel',
        permission: '/material/top-tab/receive-list'
      }, {
        label: '其他物料领用',
        name: '2',
        component: 'MaterialReceiveList',
        permission: '/material/top-tab/other-receive-list'
      }, {
        label: '其他物料退还',
        name: '3',
        component: 'MaterialReturnList',
        permission: '/material/top-tab/other-refund-list'
      }]
    };
  },
  created: function created() {},
  methods: {
    subTabClick: function subTabClick() {},
    // 领卡列表点击关联申请单：切换到其他物料领用tab并回填物料申请单
    handleGotoMaterialReceive: function handleGotoMaterialReceive(code) {
      var _this = this;
      var alreadyOnTab = this.subActiveName === '2';
      this.materialReceiveCode = code;
      this.subActiveName = '2';
      // 已在该tab时，初始化的 prop 不会变化，直接通过 ref 触发回填搜索
      if (alreadyOnTab) {
        this.$nextTick(function () {
          var ref = _this.$refs.MaterialReceiveList;
          var comp = Array.isArray(ref) ? ref[0] : ref;
          if (comp && comp.fillSearchCode) comp.fillSearchCode(code);
        });
      }
    }
  }
};